<template>
  <div class="demo-app">
    <a-config-provider :locale="zhCN">
      <router-view />
    </a-config-provider>
    <!-- <div class="map-wrapper">
      <GMap/>
    </div> -->
  </div>
</template>

<script lang="ts" setup>
import zhCN from 'ant-design-vue/es/locale/zh_CN'
</script>
<style lang="scss" scoped>
.demo-app {
  width: 100%;
  height: 100%;

  .map-wrapper {
    height: 100%;
    width: 100%;
  }
}
</style>

<style lang="scss">
#demo-app {
  width: 100%;
  height: 100%
}
.amap-logo {
  display: none !important;
}
.amap-copyright {
  display: none !important;
}
</style>
